import React from "react"
import { Box } from "@shared-components/Box/Box"
import { arrayHasAny } from "../../shared/helpers/array"
import {
  cellHeaderStyle,
  cellStyles,
  cellStackStyles,
  containerStyles,
  containerMobileStackStyles,
  rowHeaderStyles,
  rowStyles,
  wrapStyles,
  lightLayoutWrapStyles,
  lightLayoutContentStyles,
  lightLayoutRowStyles,
  contentStyles,
  rowBaseStyle,
  rowBaseStackOnMobileStyle,
} from "./styles"
import { TableModule } from "../../carlsberg-headless/types/modules/Table"
import { Container } from "@shared-components/Container/Container"
import ParseHtmlToReact from "@shared-components/ParseHtmlToReact/ParseHtmlToReact"
import { THEMES_MAP } from "../../carlsberg-headless/themes-map"
import { TAXONOMIES_MAP } from "../../carlsberg-headless/taxonomies-map"

export type TableProps = TableModule

const isHeaderRow = (themes: string[]): boolean =>
  arrayHasAny(themes)
    ? themes.includes(THEMES_MAP.table_module.table_module_table_header)
    : false

const Table: React.FC<TableProps> = ({ rows, cbKey, taxonomies }) => {
  if (!rows) return null

  const isLightTableLayout = taxonomies.includes(
    TAXONOMIES_MAP.table_module.table_module_light_layout
  )
  const stackColumnsOnMobile = taxonomies.includes(
    TAXONOMIES_MAP.table_module.table_module_stack_on_mobile
  )

  return (
    <Container
      key={cbKey}
      sx={{ ...wrapStyles, ...(isLightTableLayout && lightLayoutWrapStyles) }}
    >
      <Box
        sx={stackColumnsOnMobile ? containerMobileStackStyles : containerStyles}
      >
        {rows &&
          rows?.length > 0 &&
          rows.map(({ key, themes, cells }) => (
            <Box
              sx={{
                ...(stackColumnsOnMobile
                  ? rowBaseStackOnMobileStyle
                  : rowBaseStyle),
                ...(isHeaderRow(themes)
                  ? rowHeaderStyles
                  : isLightTableLayout
                  ? lightLayoutRowStyles
                  : rowStyles),
              }}
              key={key}
            >
              {cells &&
                cells?.length > 0 &&
                cells.map(({ key, content }) => (
                  <Box
                    sx={
                      isHeaderRow(themes)
                        ? cellHeaderStyle
                        : !stackColumnsOnMobile
                        ? cellStyles
                        : cellStackStyles
                    }
                    key={key}
                  >
                    {content && (
                      <ParseHtmlToReact
                        sx={{
                          ...contentStyles,
                          ...(isLightTableLayout && lightLayoutContentStyles),
                        }}
                        html={content}
                      />
                    )}
                  </Box>
                ))}
            </Box>
          ))}
      </Box>
    </Container>
  )
}

export { Table }
